import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  AbandonSalesOrderByBillingCycle,
  AbandonSalesOrderByBillingCycleVariables,
} from '@/graphql/contracts/_generated_/abandonSalesOrderByBillingCycle.mutation';
import AbandonSalesOrderByBillingCycleMutation from '@/graphql/contracts/abandonSalesOrderByBillingCycle.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import { AbandonSalesOrderByBillingCycleInputType } from '@/graphql/contracts/_generated_/contracts';

export default function useAbandonSalesOrderByBillingCycle() {
  const [_abandonSalesOrder, { loading }] = useMutation<
  AbandonSalesOrderByBillingCycle,
  AbandonSalesOrderByBillingCycleVariables
  >(AbandonSalesOrderByBillingCycleMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
    onCompleted: () => {
      notificationService.open({
        title: 'Sales Order Abandoned',
        text: 'Sales order successfully abandoned',
        type: 'success',
      });
    },
  });

  const abandonSalesOrderByBillingCycle = async (
    input: AbandonSalesOrderByBillingCycleInputType
  ) => {
    const response = await _abandonSalesOrder({
      variables: { input },
    });

    return response.data?.abandonSalesOrderByBillingCycle;
  };

  return {
    abandonSalesOrderByBillingCycle,
    isLoadingAbandonSalesOrder: loading,
  } as const;
}
